import React from 'react';
import './EventSingle.css';

import { Car, Lightbox, PageSidebar, PageTitle } from '../../../components';

import { FaCheck, FaStar } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';
import { getCarsByIds } from '../../../utils';



const EventSingle = () => { 

  // Get the event data from the router state
  const location = useLocation();  
  const event = location.state; 

  // Get the speakers for this session
  const featuredCars = getCarsByIds(event.featuredCarIds);

  return (
    <>
      {/* Page Title */}
      <PageTitle title={event.title} page={'Event Single'} />

      <section className='event-single page-single'>

        <div className='event-info page-info'>

          {/* Event Image */}
          <div className='image'>
            <img src={event.image} alt={event.title} />
          </div>

          <div className='content'>

            {/* Event Heading */}
            <h3 className='main-heading'>{event.title}</h3>

            {/* Event Description */}
            {event.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Event Image gallery */}
            <Lightbox images={event.gallery} />

            {/* Event Highlights Section */}
            <div className='sub-section'>
              <h3 className='sub-heading'>Event Highlights</h3>
              
              {/* List of Highlight Points */}
              <ul>
                {event.highlights.map((highlight, index) => (
                  <li key={index}>
                    <div className='icon'><FaCheck /></div>
                    {highlight}
                  </li>
                ))}
              </ul>
            </div>

            {/* How to Participate Section */}
            <div className='sub-section'>
              <h3 className='sub-heading'>How to Participate</h3>
              
              {/* List of Schedule Sessions */}
              <ul>
                {event.participation.map((step, index) => (
                  <li key={index}>
                    <div className='icon'><FaStar /></div>
                    {step}
                  </li>
                ))}
              </ul>
            </div>

            {/* Featured Cars Section */}
            <div className='event-cars sub-section'>
              <h3 className='sub-heading'>Featured Cars:</h3>

                <div className="car-container grid">
                  {/* Render each car component */}
                  {featuredCars.map((car) => {
                    return(  
                      <Car key={car.id} car={car} /> 
                    )
                  }) 
                  }
                </div>

            </div> 

          </div> 
        
        </div> 

        {/* Sidebar with Event Details */}
        <PageSidebar
          heading={'Event'}
          details={event.details}
          button={{ link: 'Contact-us', title: 'Register Now' }}
        />

      </section>

    </> 
  );
}

export default EventSingle;